import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsMapApiProvidor
    ,FvmsApiDtgGeoFenceService
} from "src/app/shared/service";
import {
    DtgListType
    ,DtgActionType
} from "src/app/shared/vo";

@Component({
    templateUrl: './report.geofence.his.position.component.html'
    ,providers: []
})
export class ReportGeofenceHisPositionComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() companyId:string;
    @Input() teamId:string;
    @Input() geoFenceId:string;
    @Input() dtgUnitId:string;
    @Input() dtgRegDt:string;
    @Input() dtgActionType:DtgActionType;
    mapParentW:any;
    mapParentH:any;
    companyInfo:any;
    DtgListType = DtgListType;
    currentUserInfo:any;
    userGroupId:number;
    mapService:any;
    strokeColor = "#00a0e9";
    fillColor = "#00a0e9";
    strokeWeight = 3;
    listGeofenceConf:any[];
    mapPolygon:any;
    geoFenceHis:any;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsMapApiProvidor:FvmsMapApiProvidor
        ,private fvmsApiDtgGeoFenceService:FvmsApiDtgGeoFenceService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.mapService = this.fvmsMapApiProvidor.getMapApiService();
     }

    ngOnInit() {
        this.mapService.initMapContainer("map-container-01");
        this.mapService.addControlViewMode();
        this.mapService.addControlZoom();
        this.mapService.addControlCopyright();
        this.mapService.initLatLngBounds();
        this.mapService.initGeocoder();
        // this.mapService.getMapObject().setDraggable(false);
        // this.mapService.getMapObject().setZoomable(false);
        this.reloadGeoFenceConf();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    reloadOneItem(){
        let searchInfo = {
            companyId:this.companyId
            // ,dtgTeamId:this.teamId
            ,geoFenceId:this.geoFenceId
            ,dtgUnitId:this.dtgUnitId
            ,dtgRegDt:this.dtgRegDt
        };
        this.fvmsApiDtgGeoFenceService.selectGeoFenceHis(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.geoFenceHis = apiResponse.resultValue;
                    this.drawCar();
                }
            });
    }

    reloadGeoFenceConf(){
        let searchInfo = {
            companyId:this.companyId
            // ,dtgTeamId:this.teamId
            ,geoFenceId:this.geoFenceId
        };
        this.fvmsApiDtgGeoFenceService.listGeoFenceConfLoc(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listGeofenceConf = apiResponse.resultValue;
                    this.mapService.relayout();
                    this.drawGeoFenceConf();
                    this.reloadOneItem();
                }
            });
    }

    drawGeoFenceConf(){
        let conf = this.listGeofenceConf[0];
        switch(conf.shapeType){
            case "C":
                this.drawCircle();
                break;
            case "R":
                this.drawRectangle();
                break;
            case "P":
            default:
                this.drawPolygon();
                break;
        }
    }

    drawCircle(){
        let centerConf = this.listGeofenceConf[0];
        let centerPosition = this.mapService.createLatLng(centerConf.lat,centerConf.lng);
        centerConf.radius *= 1;
        let circleBounds = this.mapService.createLatLngBounds();

        this.mapPolygon = this.mapService.createCircle({
            center : centerPosition // 원의 중심좌표입니다
            ,radius: centerConf.radius // 원의 반지름입니다 m 단위 이며 선 객체를 이용해서 얻어옵니다
            ,strokeWeight: this.strokeWeight // 선의 두께입니다
            ,strokeColor: this.strokeColor // 선의 색깔입니다
            ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
            ,strokeStyle: "solid" // 선의 스타일입니다
            ,fillColor: this.fillColor // 채우기 색깔입니다
            ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        });
        this.mapPolygon.setMap(this.mapService.getMapObject());

        this.mapService.getMapObject().setCenter(centerPosition);

        let bounds = this.mapPolygon.getBounds();
        let lat_lng1 = bounds.getNorthEast().toString().replace("(","").replace(")","").split(",");
        let lat_lng2 = bounds.getSouthWest().toString().replace("(","").replace(")","").split(",");
        circleBounds.extend(this.mapService.createLatLng(lat_lng1[0], lat_lng1[1]));
        circleBounds.extend(this.mapService.createLatLng(lat_lng2[0], lat_lng2[1]));
        this.mapService.getMapObject().setBounds(circleBounds);
    }

    drawRectangle(){
        let listLatLng = [];
        let rectangleBounds = this.mapService.createLatLngBounds();
        
        for(let a=0;a<this.listGeofenceConf.length;a++){
            let tmpConf = this.listGeofenceConf[a];
            let tmpLatLng = this.mapService.createLatLng(tmpConf.lat,tmpConf.lng);
            listLatLng.push(tmpLatLng);
            rectangleBounds.extend(tmpLatLng);
        }
        this.mapPolygon = this.mapService.createRectangle({
            strokeWeight: this.strokeWeight // 선의 두께입니다
           ,strokeColor: this.strokeColor // 선의 색깔입니다
           ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
           ,strokeStyle: 'solid' // 선의 스타일입니다
           ,fillColor: this.fillColor // 채우기 색깔입니다
           ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        });
        this.mapPolygon.setBounds(rectangleBounds);
        this.mapPolygon.setMap(this.mapService.getMapObject());
        this.mapService.getMapObject().setBounds(rectangleBounds);
    }

    drawPolygon(){
        let listLatLng = [];
        let polygonBounds = this.mapService.createLatLngBounds();

        for(let a=0;a<this.listGeofenceConf.length;a++){
            let tmpConf = this.listGeofenceConf[a];
            let tmpLatLng = this.mapService.createLatLng(tmpConf.lat,tmpConf.lng);
            listLatLng.push(tmpLatLng);
            polygonBounds.extend(tmpLatLng);
        }

        this.mapPolygon = this.mapService.createPolygon({
            strokeWeight: this.strokeWeight // 선의 두께입니다
           ,strokeColor: this.strokeColor // 선의 색깔입니다
           ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
           ,strokeStyle: 'solid' // 선의 스타일입니다
           ,fillColor: this.fillColor // 채우기 색깔입니다
           ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        });
        this.mapPolygon.setPath(listLatLng);
        this.mapPolygon.setMap(this.mapService.getMapObject());
        this.mapService.getMapObject().setBounds(polygonBounds);
    }

    drawCar(){
        // this.geoFenceHis
        let self = this;
        let imgWidth = 100;
        let imgHeight = 114;
        let sampleImgSrc = this.mapService.getSvgImgTagCarWithNo(
            this.geoFenceHis.dtgCarNo
            ,this.geoFenceHis.dtgUnitId
            ,"on"
            ,0
            ,imgWidth
            ,imgHeight
        );
        console.log("drawCar",sampleImgSrc);
        let imgOption = {
            imgSrc: sampleImgSrc
            ,imgWidth:imgWidth
            ,imgHeight:imgHeight
            ,offsetX:50
            ,offsetY:60
        };

        let idx = 0;
        let idxHistory = 0;
        let latLng = this.mapService.createLatLng(this.geoFenceHis.lat,this.geoFenceHis.lng);
        let marker = this.mapService.createMarkerFromLatLng(
            latLng
            ,0
            ,imgOption
        );

        this.mapService.addMarkerEvent(marker,"click",(function(i1,i2){
            return function(){
                // self.clickMarker(i1,i2);
            };
        })(idx,idxHistory));
        this.mapService.showMarker(marker);

        let bounds = this.mapService.getMapObject().getBounds();
        bounds.extend(latLng);
        this.mapService.getMapObject().setBounds(bounds);
    }
}